import { OwsOptionsFeatureType, getOptionsForFeature } from 'owa-outlook-service-option-store';
import { getAccountScopeUserSettings } from 'owa-session-store/lib/selectors/getAccountScopeUserSettings';
import getGlobalSettingsAccountMailboxInfo from 'owa-account-source-list-store/lib/selectors/getGlobalSettingsAccountMailboxInfo';

import type { AppBarDisplayModeOptions } from 'owa-outlook-service-option-store';

export function isAppBarDisplayModeColorfulIconsEnabled(useColorfulIcons?: boolean): boolean {
    if (useColorfulIcons !== undefined) {
        return useColorfulIcons;
    }

    let colorfulIconsEnabled = undefined;

    const userOptions = getOptionsForFeature<AppBarDisplayModeOptions>(
        OwsOptionsFeatureType.AppBarDisplayMode
    );

    if (userOptions) {
        colorfulIconsEnabled = userOptions.colorfulIconsEnabled;
    } else {
        const primeSettingsItems = getAccountScopeUserSettings(
            getGlobalSettingsAccountMailboxInfo()
        )?.PrimeSettings?.Items;

        if (primeSettingsItems) {
            for (const primeSetting of primeSettingsItems) {
                if (primeSetting.Id === 'AppBarDisplayModeOptions') {
                    colorfulIconsEnabled = primeSetting.Value?.options?.[0]?.colorfulIconsEnabled;
                    break;
                }
            }
        }
    }

    // Default to true if user setting is not found as colorful icons are enabled by default
    return colorfulIconsEnabled ?? true;
}

export function isAppBarDisplayModeShowLabelsEnabled(): boolean {
    const userOptions = getOptionsForFeature<AppBarDisplayModeOptions>(
        OwsOptionsFeatureType.AppBarDisplayMode
    );

    let showLabelsEnabled = undefined;

    if (userOptions) {
        showLabelsEnabled = userOptions.labelsEnabled;
    } else {
        const primeSettingsItems = getAccountScopeUserSettings(
            getGlobalSettingsAccountMailboxInfo()
        )?.PrimeSettings?.Items;
        if (primeSettingsItems) {
            for (const primeSetting of primeSettingsItems) {
                if (primeSetting.Id === 'AppBarDisplayModeOptions') {
                    showLabelsEnabled = primeSetting.Value?.options?.[0]?.labelsEnabled;
                    break;
                }
            }
        }
    }

    // Default to false if user setting is not found as labels are disabled by default
    return !!showLabelsEnabled;
}
